import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-qr-codes",
  templateUrl: "./qr-codes.component.html",
  styleUrls: ["./qr-codes.component.scss"],
})
export class QrCodesComponent implements OnInit {
  public showQR: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  generateQr() {
    this.showQR = true;
  }

  downloadQr() {}
}
